const STORAGE_KEY = "examFontSizeScale";
const LEGACY_STORAGE_KEY = "examFontSizeLevel";

export const EXAM_FONT_SCALE_MIN = 1.0;
export const EXAM_FONT_SCALE_MAX = 2.0;
export const EXAM_FONT_SCALE_STEP = 0.05;
export const EXAM_FONT_SCALE_DEFAULT = 1.0;

const LEGACY_SCALE_MAP = {
  sm: 0.9,
  md: 1,
  lg: 1.15,
  xl: 1.3,
};

function clampScale(scale) {
  const num = Number(scale);
  if (Number.isNaN(num)) {
    return EXAM_FONT_SCALE_DEFAULT;
  }
  const clamped = Math.min(EXAM_FONT_SCALE_MAX, Math.max(EXAM_FONT_SCALE_MIN, num));
  return Math.round(clamped * 100) / 100;
}

export function getExamFontScale() {
  const saved = sessionStorage.getItem(STORAGE_KEY);
  if (saved !== null && saved !== "") {
    return clampScale(saved);
  }
  const legacy = sessionStorage.getItem(LEGACY_STORAGE_KEY);
  if (legacy && LEGACY_SCALE_MAP[legacy]) {
    return clampScale(LEGACY_SCALE_MAP[legacy]);
  }
  return EXAM_FONT_SCALE_DEFAULT;
}

export function setExamFontScale(scale) {
  const clamped = clampScale(scale);
  sessionStorage.setItem(STORAGE_KEY, String(clamped));
  return clamped;
}

export function increaseExamFontScale(scale) {
  const current = scale != null ? clampScale(scale) : getExamFontScale();
  return setExamFontScale(current + EXAM_FONT_SCALE_STEP);
}

export function decreaseExamFontScale(scale) {
  const current = scale != null ? clampScale(scale) : getExamFontScale();
  return setExamFontScale(current - EXAM_FONT_SCALE_STEP);
}

export function canIncreaseExamFontScale(scale) {
  const current = scale != null ? clampScale(scale) : getExamFontScale();
  return current < EXAM_FONT_SCALE_MAX;
}

export function canDecreaseExamFontScale(scale) {
  const current = scale != null ? clampScale(scale) : getExamFontScale();
  return current > EXAM_FONT_SCALE_MIN;
}

export function formatExamFontScalePercent(scale) {
  return Math.round((scale != null ? clampScale(scale) : getExamFontScale()) * 100);
}

export function getExamFontStyle(scale) {
  const current = scale != null ? clampScale(scale) : getExamFontScale();
  return {
    "--exam-font-scale": String(current),
  };
}



// WEBPACK FOOTER //
// ./src/utils/examFontSize.js